import { showErrorToast } from '@shared/toasts';
import { clustersMiddleware } from './clusters';
import { OBM_API_ERRORS, budgetManagerPlatformMapping } from './omnichannel-budget-manager.constants';

export const omnichannelBudgetManagerMiddlewares = [
    clustersMiddleware,
];

export const handleBudgetManagerErrorToast = (state, action) => {
    const response = action.payload?.response?.data;
    const isClusterUnauthorized = response?.errorCode === OBM_API_ERRORS.CLUSTER_UNAUTHORIZED;
    const errorMetadata = response?.errorMetadata;

    const networkId = errorMetadata?.networkId;
    const clusterName = errorMetadata?.clusterName;
    const platform = errorMetadata?.platform;
    const formattedPlatform = budgetManagerPlatformMapping[platform];

    if (isClusterUnauthorized && networkId && clusterName && formattedPlatform) {
        return showErrorToast({
            message: `Cluster "${clusterName}" contains campaigns from ${formattedPlatform} account ${networkId}.`
            + "You don't have access to this account, so you can't make changes.",
            options: {
                autoClose: false,
            },
        });
    }

    return showErrorToast({
        message: action.payload.response.data.message,
    });
};
